import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
// "Handover to Collator" uses the existing useSubmitAppraisal hook — the appraisee's
// "submit" action was the pre-existing endpoint before the AC1 UI copy named it "Handover".
import { useSubmitAppraisal } from '@/queries/useAppraisalDetail';

interface HandoverToCollatorDialogProps {
  open: boolean;
  onClose: () => void;
  appraisalId: string;
  rowVersion?: string;
  onSuccess: () => void;
  onError: (error: unknown) => void;
}

export function HandoverToCollatorDialog({
  open,
  onClose,
  appraisalId,
  rowVersion,
  onSuccess,
  onError,
}: HandoverToCollatorDialogProps) {
  const { mutate, isPending } = useSubmitAppraisal(appraisalId);

  const handleConfirm = () => {
    mutate(
      { rowVersion },
      {
        onSuccess: () => {
          onSuccess();
        },
        onError: (error) => {
          onError(error);
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Handover to Collator</DialogTitle>
      <DialogContent>
        <Typography>
          You are about to hand over this appraisal form to the Collator. This confirms that your
          self-assessment is complete and ready for the Collator's review.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={isPending}>
          Handover to Collator
        </Button>
      </DialogActions>
    </Dialog>
  );
}
